export { default } from '@shikijs/langs/haml'
